<his-plam [label]="setting().label | hisUi" [helptext]="setting().helptext | hisUi"
          [required]="setting().required"
          [title]="title()">
    <input #content type="checkbox" [(ngModel)]="setting().value" binary="true" class="inputWidth100"
           [readonly]="setting().readonly">
</his-plam>
